/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ElementType, TabElementInfo, TabElementState } from './data-contracts'
import { HttpClient, RequestParams } from './http-client'

export class StateClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
 * @description Устанавливает / снимает пометки с выбранного элемента дерева с Id = projectElementId для вкладки с Id = tabId. Также помечаются все зависимые дочерние и родительские элементы по иерархии в соответствии с конфигуратором. Для родительского элемента: если все дочерние элементы имеют состояние state = Unchecked устанавливается состояние Unchecked, если все дочерние элементы имеют состояние state = Checked устанавливается состояние Checked, иначе устанавливается состояние Indeterminate.
 * 
 * @tags State
 * @summary Установить состояние элементов дерева объектов для вкладки. Запись в БД.
Получение элементов вкладки, зависимых от выбранного элемента, с новыми состояниями.
 * @request POST:/objecttree/State/StateElement/{projectId}/{projectElementId}
 * @secure
 */
  stateSetStateTabElements = (
    projectId: string,
    projectElementId: string,
    query: {
      /**
       * Идентификатор вкладки
       * @format uuid
       */
      tabId: string
      /** Состояние элемента вкладки */
      state: TabElementState
    },
    params: RequestParams = {},
  ) =>
    this.http.request<TabElementInfo[], any>({
      path: `/objecttree/State/StateElement/${projectId}/${projectElementId}`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
 * @description Устанавливает / снимает пометки с выбранного элемента дерева для вкладки с Id = tabId. Также помечаются все зависимые дочерние и родительские элементы по иерархии в соответствии с конфигуратором. Для родительского элемента: если все дочерние элементы имеют состояние state = Unchecked устанавливается состояние Unchecked, если все дочерние элементы имеют состояние state = Checked устанавливается состояние Checked, иначе устанавливается состояние Indeterminate.
 * 
 * @tags State
 * @summary Установить состояние элементов дерева объектов для вкладки. Запись в БД.
Получение элементов вкладки, зависимых от выбранного элемента, с новыми состояниями.
 * @request POST:/objecttree/State/StateElementByEntityId/{projectId}/{entityId}
 * @secure
 */
  stateSetStateTabElementsByEntityId = (
    projectId: string,
    entityId: string,
    query: {
      /** Типы объектов */
      elementType: ElementType
      /**
       * Идентификатор вкладки
       * @format uuid
       */
      tabId: string
      /** Состояние элемента вкладки */
      state: TabElementState
    },
    params: RequestParams = {},
  ) =>
    this.http.request<TabElementInfo[], any>({
      path: `/objecttree/State/StateElementByEntityId/${projectId}/${entityId}`,
      method: 'POST',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    })
}
